import { Component, OnInit } from '@angular/core';
import {OverlayConfig, OverlayRef} from 'exc-controls';
import {ExcRestService} from 'exc-rest';
import {ExcTranslation} from 'exc-core';

@Component({
  selector: 'app-modal-geofence-add-component',
  templateUrl: './modal-geofence-add-component.component.html',
  styles: []
})
export class ModalGeofenceAddComponentComponent extends ExcTranslation implements OnInit {
  busy = false;
  gfName = '' ;
  gfColor = 'RED';
  gfType = 'CIRCLE';
  gfBehaviour = 'IN';
  gfNote = '';
  gfData = '';

  constructor(public overlayConfig: OverlayConfig, public overlayRef: OverlayRef,  public excRest: ExcRestService) {
    super();
    const _self = this;
  }

  ngOnInit() {
    const _self = this;
    /*if (_self.overlayConfig.data.Data === null) {
    } else {
      _self.geofence = Object.assign({}, _self.overlayConfig.data.Data);
    }*/
  }

  editGeoFence() {
    const _self = this;
    _self.overlayRef.close({proceed: true,
        geofence: {
          gfName: _self.gfName,
          gfColor:  _self.gfColor,
          gfType: _self.gfType,
          gfBehaviour:  _self.gfBehaviour,
          gfNote: _self.gfNote,
          gfData: _self.gfData
        }
      });
  }

}
